import React, { useEffect, useState } from 'react'
import RiskQuestionnarieForm from './RiskQuestionnarieForm';
import Service from '../../services';
import { useNavigate, useParams } from 'react-router-dom';
import SpinnerModel from '../../commonfields/SpinnerModel';
import { RoutesEnum } from '../../utils/RoutesUtil';
import { TrackersEnum } from '../../models/TrackerModel';
import { RiskEnums } from '../../utils/RiskUtils';

const RiskQuestionnarie = (props:any) => {
  const {modalToggle,questionsData,headerText,getQuestionsData} = props
  const [formIntialValues, setFormIntialValues] = useState<any>({})
  const [loader,setLoader] = useState(false)
  const { clientProductId } = useParams()
  const navigate = useNavigate();
  const service = new Service();

  const setQuestions = (sortedData: any) => {
    const initialValues: Record<string, any> = {};
    sortedData && sortedData.length > 0 && sortedData?.forEach((element: any) => {
      if (element.parameterType === RiskEnums.CURRENCY || element.parameterType === RiskEnums.NUMERICID) {
        const answer = element.answer != null ? element.answer : null;
        const val = {
          ["question_" + element.riskParameterId.toString()]: answer,
        };
        Object.assign(initialValues, val);
      }
      setFormIntialValues(initialValues)
    })
  }

  const handleAnswer =(answer:any)=>{
    if(answer){
      if(answer.length > 1){
        return answer
      }
      else{
        return ""
      }
    }
    else{
      return ""
    }
  }

  const onSaveQuestion =  (question: any) => {
    const currentQuestion = questionsData.filter((element: any) => Object.keys(question.questionData)[0] == element.riskParameterId)
    let PostQuestionData: any = {
      parameterResponseId: currentQuestion[0]?.parameterResponseId ? currentQuestion[0]?.parameterResponseId : null,
      riskParameterId: Object.keys(question.questionData)[0],
      clientProductsId: clientProductId,
      answer: handleAnswer(question.questionData[Object.keys(question.questionData)[0]])
    };
    service.onSaveResponse(PostQuestionData).then(()=>{
      getQuestionsData()
    }).catch((error: any) => {
    });
  }

  const handleMoveStatus = () =>{
    modalToggle()
    const orgProductsListRaw = sessionStorage.getItem("orgProductsList")
    const orgProductsList = orgProductsListRaw && JSON.parse(orgProductsListRaw)
    service.moveToNextStatus(clientProductId || "").then((response:any)=>{
      navigate(`/${RoutesEnum.TRACKER}/${(TrackersEnum.UNDERWRITING)}/${orgProductsList[0].orgLevelProductId}`)
    }).catch((error: any) => {
  });
  }

  useEffect(() => {
    setQuestions(questionsData)
  }, [])

  return (
    <div>
      {loader && (
          <SpinnerModel
            value={""}
            color={"primary"}
            size={""}
            type={"border"}
          />
        )}
      <RiskQuestionnarieForm 
        questionsData={questionsData} 
        formIntialValues={formIntialValues} 
        onSaveQuestion={onSaveQuestion} 
        headerText={headerText}
        handleMoveStatus={handleMoveStatus}
        handleToggle={modalToggle}
        />
    </div>
  )
}

export default RiskQuestionnarie